module.exports = "/packs/careerchange_survey-pc-bf6bb8c3e8e462d20c6822ebdeb9b314.jpg";